<template>
  <div>
    <el-container>
      <el-header height="auto">
        <el-row>
          <el-col :span="13">
            <h3>商城订单</h3>
            <hr/>
            <div class="order">
              <div class="order-item" @click="toOrderPage()">
                <div class="order-item-left">
                  <svg t="1593669767010" class="icon" viewBox="0 0 1024 1024" version="1.1"
                       xmlns="http://www.w3.org/2000/svg" p-id="3047" width="48" height="48">
                    <path
                        d="M277.33344 85.333333V42.794667C277.33344 19.157333 296.320107 0 319.808107 0H704.21344C727.658773 0 746.666773 19.136 746.666773 42.794667V85.333333h149.397334C919.594773 85.333333 938.666773 104.512 938.666773 128.106667v853.12A42.666667 42.666667 0 0 1 896.064107 1024H127.936107A42.709333 42.709333 0 0 1 85.33344 981.226667V128.106667A42.666667 42.666667 0 0 1 127.936107 85.333333H277.33344z m0 85.333334H191.850773C180.330773 170.666667 170.666773 180.224 170.666773 192v725.333333c0 11.626667 9.472 21.333333 21.184 21.333334h640.298667c11.52 0 21.184-9.557333 21.184-21.333334V192c0-11.626667-9.472-21.333333-21.184-21.333333H746.666773v85.205333C746.666773 279.509333 727.680107 298.666667 704.192107 298.666667H319.786773C296.34144 298.666667 277.33344 279.530667 277.33344 255.872V170.666667z m85.333333-64.213334v85.76c0 11.498667 9.6 21.12 21.482667 21.12h255.701333A21.290667 21.290667 0 0 0 661.33344 192.213333V106.453333c0-11.498667-9.6-21.12-21.482667-21.12H384.14944A21.290667 21.290667 0 0 0 362.666773 106.453333zM234.666773 448a42.666667 42.666667 0 0 1 42.602667-42.666667h469.461333c23.530667 0 42.602667 18.944 42.602667 42.666667a42.666667 42.666667 0 0 1-42.602667 42.666667H277.26944A42.538667 42.538667 0 0 1 234.666773 448z m0 170.666667a42.666667 42.666667 0 0 1 42.602667-42.666667h469.461333c23.530667 0 42.602667 18.944 42.602667 42.666667a42.666667 42.666667 0 0 1-42.602667 42.666666H277.26944A42.538667 42.538667 0 0 1 234.666773 618.666667z m0 170.666666c0-23.573333 19.050667-42.666667 42.496-42.666666h235.008c23.466667 0 42.496 18.944 42.496 42.666666 0 23.573333-19.050667 42.666667-42.496 42.666667H277.162773C253.696107 832 234.666773 813.056 234.666773 789.333333z"
                        p-id="3048"></path>
                  </svg>
                </div>
                <div class="order-item-right">
                  <p class="order-item-title">总订单数</p>
                  <p class="order-item-price">{{ totalOrderCount.total || 0 }}</p>
                </div>
              </div>
              <div class="order-item" @click="toOrderPage('SECKILL')">
                <div class="order-item-left">
                  <svg t="1593661890435" class="icon" viewBox="0 0 1024 1024" version="1.1"
                       xmlns="http://www.w3.org/2000/svg" p-id="2256" width="48" height="48">
                    <path
                        d="M608.5 514.7l-64.1-16V333.9c0-10.6-7.5-19.7-17.9-21.8-10.4-2.1-20.8 3.5-24.9 13.3L400.4 568.2c-2.6 6.2-2.2 13.1 0.9 19s8.7 10.1 15.3 11.4l81.2 16.2-18 161.9c-1.2 11 5.8 21.2 16.6 24 1.9 0.5 3.7 0.7 5.6 0.7 8.8 0 17-5.3 20.5-13.7l101.2-242.8c2.5-6 2.3-12.8-0.7-18.6-3-5.8-8.2-10-14.5-11.6z m-67.3 112.2l3.1-27.5c1.3-11.5-6.4-22-17.8-24.3l-74.6-14.9 47.9-115V516c0 10.2 7 19.1 16.9 21.6l55.8 14-31.3 75.3z"
                        p-id="2257"></path>
                    <path
                        d="M857.8 242.2l57.6-57.6c8.7-8.7 8.7-22.8 0-31.5s-22.8-8.7-31.5 0l-57.6 57.6C743.2 135.2 632.9 89 512 89 254.2 89 44.5 298.8 44.5 556.5S254.2 1024 512 1024s467.5-209.7 467.5-467.5c0-120.9-46.2-231.2-121.7-314.3zM534.3 978.9v-66.2c0-12.3-10-22.3-22.3-22.3s-22.3 10-22.3 22.3v66.2C274.2 967.7 100.9 794.3 89.6 578.8h66.2c12.3 0 22.3-10 22.3-22.3s-10-22.3-22.3-22.3H89.6c11.2-215.5 184.6-388.9 400.1-400.1v66.2c0 12.3 10 22.3 22.3 22.3s22.3-10 22.3-22.3v-66.2c215.5 11.2 388.9 184.6 400.1 400.1h-66.2c-12.3 0-22.3 10-22.3 22.3s10 22.3 22.3 22.3h66.2c-11.3 215.5-184.6 388.9-400.1 400.1zM423 44.5h178c12.3 0 22.3-10 22.3-22.3S613.3 0 601 0H423c-12.3 0-22.3 10-22.3 22.3s10 22.2 22.3 22.2z"
                        p-id="2258"></path>
                  </svg>
                </div>
                <div class="order-item-right">
                  <p class="order-item-title">秒杀订单</p>
                  <p class="order-item-price">{{ totalOrderCount.killTotal || 0 }}</p>
                </div>
              </div>
              <div class="order-item" @click="toOrderPage('TEAM')">
                <div class="order-item-left">
                  <svg t="1593669825926" class="icon" viewBox="0 0 1041 1024" version="1.1"
                       xmlns="http://www.w3.org/2000/svg" p-id="3928" width="48" height="48">
                    <path
                        d="M1039.968965 869.66397q5.038609 159.220055-155.189167 154.181445l-832.378261 0 0-1007.721866 987.567428 0 0 853.54042zM852.532698 958.343494q88.679524 5.038609 84.648637-79.610027l0-794.08483-781.992168 0 0 873.694857 697.343531 0zM721.528856 283.169844l159.220055 0 0 65.501921-159.220055 0 0 407.119634q5.038609 137.050174-147.127392 132.011564l-59.45559 0 0-66.509643 55.424703 0q61.471034 5.038609 56.432424-65.501921l0-407.119634-56.432424 0q-60.463312 347.664044-349.679487 515.953595l0-66.509643q106.818518-88.679524 169.801134-199.528929t86.16022-249.915023l-265.030851 0 0-65.501921 415.181409 0 0-142.088783 94.725855 0 0 142.088783z"
                        p-id="3929"></path>
                  </svg>
                </div>
                <div class="order-item-right">
                  <p class="order-item-title">团购订单</p>
                  <p class="order-item-price">{{ totalOrderCount.teamTotal || 0 }}</p>
                </div>
              </div>
              <div class="order-item" @click="toOrderPage('COMMON')">
                <div class="order-item-left">
                  <svg t="1593669884252" class="icon" viewBox="0 0 1024 1024" version="1.1"
                       xmlns="http://www.w3.org/2000/svg" p-id="6451" width="48" height="48">
                    <path
                        d="M896 535.68V896c0 53.76-46.464 96-102.4 96H230.4c-55.936 0-102.4-42.24-102.4-96V535.68A146.752 146.752 0 0 1 32 397.12l1.28-8.768 63.488-222.72A96 96 0 0 1 189.056 96h643.52a96 96 0 0 1 92.096 68.8l65.984 223.232 1.344 9.024A146.56 146.56 0 0 1 896 535.68zM192 543.104V896c0 16.96 16.576 32 38.4 32h563.2c21.824 0 38.4-15.04 38.4-32V543.104a142.976 142.976 0 0 1-95.936-53.632 142.592 142.592 0 0 1-112 54.528 142.656 142.656 0 0 1-112-54.528 142.592 142.592 0 0 1-112 54.528 142.592 142.592 0 0 1-112-54.528c-23.232 29.248-57.344 49.28-96.064 53.632zM176 480C220.032 480 256 443.072 256 397.12h64C320 443.072 356.032 480 400 480c44.032 0 80-36.928 80-82.88h64c0 45.952 36.032 82.88 80.064 82.88 43.968 0 80-36.928 80-82.88h64c0 45.952 36.032 82.88 80 82.88 42.624 0 77.76-34.624 79.808-78.592l-64.64-218.496a32 32 0 0 0-30.656-22.912H189.056a32 32 0 0 0-30.72 23.232L96.064 401.28c2.048 44.032 37.184 78.72 79.872 78.72z"
                        p-id="6452"></path>
                  </svg>
                </div>
                <div class="order-item-right">
                  <p class="order-item-title">普通订单</p>
                  <p class="order-item-price">{{ totalOrderCount.commonTotal || 0 }}</p>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :offset="1" :span="10">
            <h3>今日订单</h3>
            <hr/>
            <div class="order">
              <div class="order-item" @click="toOrderPage('SECKILL')">
                <div class="order-item-left">
                  <svg t="1593661890435" class="icon" viewBox="0 0 1024 1024" version="1.1"
                       xmlns="http://www.w3.org/2000/svg" p-id="2256" width="48" height="48">
                    <path
                        d="M608.5 514.7l-64.1-16V333.9c0-10.6-7.5-19.7-17.9-21.8-10.4-2.1-20.8 3.5-24.9 13.3L400.4 568.2c-2.6 6.2-2.2 13.1 0.9 19s8.7 10.1 15.3 11.4l81.2 16.2-18 161.9c-1.2 11 5.8 21.2 16.6 24 1.9 0.5 3.7 0.7 5.6 0.7 8.8 0 17-5.3 20.5-13.7l101.2-242.8c2.5-6 2.3-12.8-0.7-18.6-3-5.8-8.2-10-14.5-11.6z m-67.3 112.2l3.1-27.5c1.3-11.5-6.4-22-17.8-24.3l-74.6-14.9 47.9-115V516c0 10.2 7 19.1 16.9 21.6l55.8 14-31.3 75.3z"
                        p-id="2257"></path>
                    <path
                        d="M857.8 242.2l57.6-57.6c8.7-8.7 8.7-22.8 0-31.5s-22.8-8.7-31.5 0l-57.6 57.6C743.2 135.2 632.9 89 512 89 254.2 89 44.5 298.8 44.5 556.5S254.2 1024 512 1024s467.5-209.7 467.5-467.5c0-120.9-46.2-231.2-121.7-314.3zM534.3 978.9v-66.2c0-12.3-10-22.3-22.3-22.3s-22.3 10-22.3 22.3v66.2C274.2 967.7 100.9 794.3 89.6 578.8h66.2c12.3 0 22.3-10 22.3-22.3s-10-22.3-22.3-22.3H89.6c11.2-215.5 184.6-388.9 400.1-400.1v66.2c0 12.3 10 22.3 22.3 22.3s22.3-10 22.3-22.3v-66.2c215.5 11.2 388.9 184.6 400.1 400.1h-66.2c-12.3 0-22.3 10-22.3 22.3s10 22.3 22.3 22.3h66.2c-11.3 215.5-184.6 388.9-400.1 400.1zM423 44.5h178c12.3 0 22.3-10 22.3-22.3S613.3 0 601 0H423c-12.3 0-22.3 10-22.3 22.3s10 22.2 22.3 22.2z"
                        p-id="2258"></path>
                  </svg>
                </div>
                <div class="order-item-right">
                  <p class="order-item-title">秒杀订单</p>
                  <p class="order-item-price">{{ toDayTotalOrderCount.killTotal || 0 }}</p>
                </div>
              </div>
              <div class="order-item" @click="toOrderPage('TEAM')">
                <div class="order-item-left">
                  <svg t="1593669825926" class="icon" viewBox="0 0 1041 1024" version="1.1"
                       xmlns="http://www.w3.org/2000/svg" p-id="3928" width="48" height="48">
                    <path
                        d="M1039.968965 869.66397q5.038609 159.220055-155.189167 154.181445l-832.378261 0 0-1007.721866 987.567428 0 0 853.54042zM852.532698 958.343494q88.679524 5.038609 84.648637-79.610027l0-794.08483-781.992168 0 0 873.694857 697.343531 0zM721.528856 283.169844l159.220055 0 0 65.501921-159.220055 0 0 407.119634q5.038609 137.050174-147.127392 132.011564l-59.45559 0 0-66.509643 55.424703 0q61.471034 5.038609 56.432424-65.501921l0-407.119634-56.432424 0q-60.463312 347.664044-349.679487 515.953595l0-66.509643q106.818518-88.679524 169.801134-199.528929t86.16022-249.915023l-265.030851 0 0-65.501921 415.181409 0 0-142.088783 94.725855 0 0 142.088783z"
                        p-id="3929"></path>
                  </svg>
                </div>
                <div class="order-item-right">
                  <p class="order-item-title">团购订单</p>
                  <p class="order-item-price">{{ toDayTotalOrderCount.teamTotal || 0 }}</p>
                </div>
              </div>
              <div class="order-item">
                <div class="order-item-left">
                  <svg t="1593669884252" class="icon" viewBox="0 0 1024 1024" version="1.1"
                       xmlns="http://www.w3.org/2000/svg" p-id="6451" width="48" height="48">
                    <path
                        d="M896 535.68V896c0 53.76-46.464 96-102.4 96H230.4c-55.936 0-102.4-42.24-102.4-96V535.68A146.752 146.752 0 0 1 32 397.12l1.28-8.768 63.488-222.72A96 96 0 0 1 189.056 96h643.52a96 96 0 0 1 92.096 68.8l65.984 223.232 1.344 9.024A146.56 146.56 0 0 1 896 535.68zM192 543.104V896c0 16.96 16.576 32 38.4 32h563.2c21.824 0 38.4-15.04 38.4-32V543.104a142.976 142.976 0 0 1-95.936-53.632 142.592 142.592 0 0 1-112 54.528 142.656 142.656 0 0 1-112-54.528 142.592 142.592 0 0 1-112 54.528 142.592 142.592 0 0 1-112-54.528c-23.232 29.248-57.344 49.28-96.064 53.632zM176 480C220.032 480 256 443.072 256 397.12h64C320 443.072 356.032 480 400 480c44.032 0 80-36.928 80-82.88h64c0 45.952 36.032 82.88 80.064 82.88 43.968 0 80-36.928 80-82.88h64c0 45.952 36.032 82.88 80 82.88 42.624 0 77.76-34.624 79.808-78.592l-64.64-218.496a32 32 0 0 0-30.656-22.912H189.056a32 32 0 0 0-30.72 23.232L96.064 401.28c2.048 44.032 37.184 78.72 79.872 78.72z"
                        p-id="6452"></path>
                  </svg>
                </div>
                <div class="order-item-right">
                  <p class="order-item-title" @click="toOrderPage()">普通订单</p>
                  <p class="order-item-price">{{ toDayTotalOrderCount.commonTotal || 0 }}</p>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <h3>商城收益</h3>
            <hr/>
            <div class="order">
              <div class="order-item">
                <div class="order-item-left">
                  <svg t="1593672672541" class="icon" viewBox="0 0 1024 1024" version="1.1"
                       xmlns="http://www.w3.org/2000/svg" p-id="8699" width="48" height="48">
                    <path
                        d="M642.2 594.1H383.9c-7.3 0-13.3-6-13.3-13.3 0-7.3 6-13.3 13.3-13.3h258.3c7.3 0 13.3 6 13.3 13.3 0 7.3-6 13.3-13.3 13.3zM642.2 686.7H383.9c-7.3 0-13.3-6-13.3-13.3 0-7.3 6-13.3 13.3-13.3h258.3c7.3 0 13.3 6 13.3 13.3 0 7.4-6 13.3-13.3 13.3z"
                        p-id="8700"></path>
                    <path
                        d="M513 807c-7.3 0-13.3-6-13.3-13.3V580.8c0-7.3 6-13.3 13.3-13.3 7.3 0 13.3 6 13.3 13.3v212.9c0 7.3-5.9 13.3-13.3 13.3z"
                        p-id="8701"></path>
                    <path
                        d="M517.1 576.2c-3.2 0-6.3-1.1-8.9-3.4-5.5-4.9-5.9-13.3-1-18.8L614 435.2c4.9-5.5 13.3-5.9 18.8-1s5.9 13.3 1 18.8L527 571.8c-2.7 2.9-6.3 4.4-9.9 4.4z"
                        p-id="8702"></path>
                    <path
                        d="M509 576.2c-3.6 0-7.3-1.5-9.9-4.4L392.3 452.9c-4.9-5.5-4.5-13.9 1-18.8s13.9-4.5 18.8 1L518.9 554c4.9 5.5 4.5 13.9-1 18.8-2.6 2.2-5.7 3.4-8.9 3.4z"
                        p-id="8703"></path>
                    <path
                        d="M667.6 323.4h-61c143.6 52.8 248.3 218.9 248.3 360.7 0 154.9-127.8 247.5-341.9 247.5S171.2 839 171.2 684.1c0-141.8 104.7-307.9 248.3-360.7h-61C232 396.9 144.6 550.5 144.6 684.1c0 169 141.2 274 368.5 274s368.5-105 368.5-274c-0.1-133.6-87.5-287.2-214-360.7zM344 262.5h50.7c-38.5-18.2-63.3-44.6-63.3-73.7 0-53.3 83.2-98.3 181.6-98.3s181.6 45 181.6 98.3c0 29.1-24.8 55.6-63.3 73.7H682c24.7-20.5 39.2-45.9 39.2-73.7 0-70.1-91.5-124.9-208.2-124.9-116.8 0-208.2 54.9-208.2 124.9 0 27.8 14.5 53.2 39.2 73.7z"
                        p-id="8704"></path>
                    <path
                        d="M707.1 336.7H319c-20.7 0-37.5-16.8-37.5-37.5v-12.4c0-20.7 16.8-37.5 37.5-37.5h388.2c20.7 0 37.5 16.8 37.5 37.5v12.4c-0.1 20.6-16.9 37.5-37.6 37.5zM319 275.8c-6 0-10.9 4.9-10.9 10.9v12.4c0 6 4.9 10.9 10.9 10.9h388.2c6 0 10.9-4.9 10.9-10.9v-12.4c0-6-4.9-10.9-10.9-10.9H319z"
                        p-id="8705"></path>
                  </svg>
                </div>
                <div class="order-item-right">
                  <p class="order-item-title">总收益</p>
                  <p class="order-item-price">
                    {{
                      totalProfit['RECEIVED'] && totalProfit['RECEIVED'].fee && '￥' + totalProfit['RECEIVED'].fee || '￥0'
                    }}</p>
                </div>
              </div>
              <div class="order-item">
                <div class="order-item-left">
                  <svg t="1593672710568" class="icon" viewBox="0 0 1024 1024" version="1.1"
                       xmlns="http://www.w3.org/2000/svg" p-id="8897" width="48" height="48">
                    <path
                        d="M753.6 222.4h24c19.2 0 33.6-14.4 33.6-32V57.6c0-19.2-14.4-33.6-33.6-33.6h-24c-19.2 0-33.6 14.4-33.6 33.6v131.2c0 19.2 14.4 33.6 33.6 33.6zM251.2 222.4h24c19.2 0 33.6-14.4 33.6-32V57.6c0-19.2-14.4-33.6-33.6-33.6h-24c-19.2 0-33.6 14.4-33.6 33.6v131.2c0 19.2 14.4 33.6 33.6 33.6z"
                        p-id="8898"></path>
                    <path
                        d="M928 134.4h-68.8v56c0 41.6-33.6 76.8-80 76.8h-24c-43.2 0-80-33.6-80-76.8V134.4h-320v56c0 41.6-33.6 76.8-80 76.8h-24c-43.2 0-80-33.6-80-76.8V134.4H105.6c-38.4 0-68.8 28.8-68.8 67.2v731.2c0 38.4 30.4 67.2 68.8 67.2h820.8c38.4 0 68.8-28.8 70.4-67.2V201.6c0-38.4-30.4-67.2-68.8-67.2zM105.6 932.8V355.2h820.8s0 577.6 1.6 577.6H105.6z"
                        p-id="8899"></path>
                    <path
                        d="M500.8 548.8l-49.6 33.6c14.4 16 33.6 41.6 60.8 75.2l54.4-35.2c-19.2-22.4-40-46.4-65.6-73.6z"
                        p-id="8900"></path>
                    <path
                        d="M553.6 451.2l14.4-14.4v-1.6H480c-51.2 68.8-118.4 121.6-196.8 155.2 11.2 12.8 25.6 28.8 41.6 54.4 80-40 142.4-89.6 188.8-148.8 43.2 59.2 102.4 107.2 180.8 144 14.4-19.2 27.2-35.2 41.6-52.8-76.8-30.4-137.6-76.8-182.4-136zM339.2 716.8h246.4c-30.4 43.2-62.4 81.6-94.4 116.8l60.8 33.6c49.6-56 89.6-108.8 123.2-155.2v-54.4h-336v59.2z"
                        p-id="8901"></path>
                  </svg>
                </div>
                <div class="order-item-right">
                  <p class="order-item-title">今日收益</p>
                  <p class="order-item-price">
                    {{
                      toDayTotalProfit['RECEIVED'] && toDayTotalProfit['RECEIVED'].fee && '￥' + toDayTotalProfit['RECEIVED'].fee || '￥0'
                    }}</p>
                </div>
              </div>
              <div class="order-item">
                <div class="order-item-left">
                  <svg t="1593672792094" class="icon" viewBox="0 0 1024 1024" version="1.1"
                       xmlns="http://www.w3.org/2000/svg" p-id="10046" width="48" height="48">
                    <path
                        d="M755.2 220.8h24c20.8 0 35.2-14.4 35.2-30.4V56c-1.6-19.2-16-32-35.2-32h-24c-20.8 0-35.2 14.4-35.2 33.6v132.8c0 16 14.4 30.4 35.2 30.4zM252.8 220.8h24c20.8 0 35.2-14.4 35.2-30.4V56c-1.6-19.2-16-32-35.2-32h-24c-20.8 0-35.2 14.4-35.2 33.6v132.8c0 16 14.4 30.4 35.2 30.4z"
                        p-id="10047"></path>
                    <path
                        d="M928 132.8h-68.8v57.6c0 43.2-35.2 76.8-78.4 76.8h-24c-43.2 0-78.4-33.6-78.4-76.8V132.8H356.8v57.6c0 43.2-35.2 76.8-78.4 76.8h-24c-43.2 0-78.4-33.6-78.4-76.8V132.8H104c-38.4 0-68.8 28.8-68.8 67.2v732.8c0 36.8 30.4 67.2 68.8 67.2h820.8c38.4 0 68.8-28.8 70.4-67.2V200c1.6-38.4-28.8-67.2-67.2-67.2z m-824 800V355.2h820.8s0 577.6 1.6 577.6H104z"
                        p-id="10048"></path>
                    <path
                        d="M360 456v169.6c0 52.8-4.8 91.2-9.6 116.8-8 24-25.6 51.2-51.2 76.8 20.8 14.4 38.4 30.4 59.2 48 20.8-19.2 35.2-36.8 43.2-54.4 9.6-20.8 16-46.4 22.4-76.8h201.6v32c0 20.8-9.6 30.4-35.2 30.4-22.4 0-46.4 0-76.8-1.6 6.4 20.8 12.8 44.8 16 67.2 46.4 0 78.4-1.6 99.2-1.6 20.8 0 35.2-8 44.8-20.8 9.6-14.4 16-33.6 16-59.2V456H360z m260.8 219.2H422.4c1.6-24 1.6-43.2 0-51.2h198.4v51.2z m0-108.8H422.4v-51.2h198.4v51.2z"
                        p-id="10049"></path>
                  </svg>
                </div>
                <div class="order-item-right">
                  <p class="order-item-title">本月收益</p>
                  <p class="order-item-price">
                    {{
                      toMonthTotalProfit['RECEIVED'] && toMonthTotalProfit['RECEIVED'].fee && '￥' + toMonthTotalProfit['RECEIVED'].fee || 0
                    }}</p>
                </div>
              </div>
            </div>
          </el-col>

          <el-col :span="13" :offset="1">
            <h3>订单状态</h3>
            <hr/>
            <div class="order">
              <div class="order-item">
                <div class="order-item-left">
                  <svg t="1593673523397" class="icon" viewBox="0 0 1296 1024" version="1.1"
                       xmlns="http://www.w3.org/2000/svg" p-id="10644" width="48" height="48">
                    <path
                        d="M1010.46696 1024H39.471366a39.471366 39.471366 0 0 1-39.471366-39.471366V286.449339A286.449339 286.449339 0 0 1 286.449339 0H1257.444934a39.471366 39.471366 0 0 1 39.471366 39.471366v698.079295a286.449339 286.449339 0 0 1-286.44934 286.449339zM79.506608 944.493392h930.960352a207.506608 207.506608 0 0 0 206.942732-206.942731V79.506608H286.449339a207.506608 207.506608 0 0 0-206.942731 206.942731z"
                        p-id="10645"></path>
                    <path
                        d="M44.546256 227.806167h1217.409691v187.770926H44.546256zM432.493392 861.603524H197.356828a39.471366 39.471366 0 0 1-39.471365-39.471365v-155.06608a39.471366 39.471366 0 0 1 39.471365-39.471365h235.136564a39.471366 39.471366 0 0 1 39.471366 39.471365v155.06608a39.471366 39.471366 0 0 1-39.471366 39.471365z m-195.101322-78.942731H394.713656v-76.123348H237.39207z"
                        p-id="10646"></path>
                  </svg>
                </div>
                <div class="order-item-right">
                  <p class="order-item-title">代付款</p>
                  <p class="order-item-price">
                    {{ totalProfit['ORDERD'] && totalProfit['ORDERD'].amount || '0' }}</p>
                </div>
              </div>
              <div class="order-item">
                <div class="order-item-left">
                  <svg t="1593673560062" class="icon" viewBox="0 0 1024 1024" version="1.1"
                       xmlns="http://www.w3.org/2000/svg" p-id="10860" width="48" height="48">
                    <path d="M698.181818 372.363636h93.090909l186.181818 186.181819v93.090909H698.181818V372.363636z"
                          p-id="10861"></path>
                    <path
                        d="M930.909091 512.768V791.272727a46.545455 46.545455 0 0 1-46.545455 46.545455h-48.872727a116.363636 116.363636 0 0 1-228.072727 0H370.036364a116.363636 116.363636 0 0 1-228.072728 0H93.090909a46.545455 46.545455 0 0 1-46.545454-46.545455V139.636364a46.545455 46.545455 0 0 1 46.545454-46.545455h418.909091a46.545455 46.545455 0 0 1 46.545455 46.545455v186.181818h185.413818a22.923636 22.923636 0 0 1 16.849454 6.679273l163.421091 163.42109a22.853818 22.853818 0 0 1 6.679273 16.849455zM256 884.363636a69.818182 69.818182 0 1 0-69.818182-69.818181 69.818182 69.818182 0 0 0 69.818182 69.818181z m256-512V139.636364H93.090909v651.636363h48.872727a116.363636 116.363636 0 0 1 228.072728 0H512V372.363636z m209.454545 512a69.818182 69.818182 0 1 0-69.818181-69.818181 69.818182 69.818182 0 0 0 69.818181 69.818181z m-69.818181-302.545454v-209.454546h-93.090909v418.909091h48.872727a116.363636 116.363636 0 0 1 228.072727 0H884.363636v-186.181818h-209.454545a23.272727 23.272727 0 0 1-23.272727-23.272727z m83.781818-209.454546H698.181818v186.181819h186.181818v-37.236364z"
                        p-id="10862"></path>
                  </svg>
                </div>
                <div class="order-item-right">
                  <p class="order-item-title">待发货</p>
                  <p class="order-item-price">
                    {{ totalProfit['PAYED'] && totalProfit['PAYED'].amount || '0' }}</p>
                </div>
              </div>
              <div class="order-item">
                <div class="order-item-left">
                  <svg t="1593673596904" class="icon" viewBox="0 0 1024 1024" version="1.1"
                       xmlns="http://www.w3.org/2000/svg" p-id="11643" width="48" height="48">
                    <path
                        d="M496.938013 1024l-9.176997-4.146378C472.979836 1013.209858 125.496639 855.097834 103.916355 671.677371l-0.155339-2.712472V150.799104L496.890217 0l413.466766 145.051531 0.645257 15.713219c16.394324 401.493652 7.563854 499.548917 0 526.876774-1.087379 157.10829-363.172517 314.837939-404.803584 332.463032zM150.088125 667.530993C166.410754 793.893951 397.902913 926.888723 497.535474 973.335325c147.560866-63.952203 370.342046-194.879761 367.115758-288.358477l-0.29873-8.591486 3.668409-4.576549c10.192681-36.337565 4.779686-303.366692-2.73637-493.502614L497.583271 49.457804 150.088125 182.691561z"
                        p-id="11644"></path>
                    <path
                        d="M416.53174 339.286034h241.37416q34.485437 0 68.970874-2.043316v32.454071q-34.521285-1.995519-68.970874-2.019418h-93.299477v34.485437h71.00224q34.473488 0 64.92009-2.031367v36.480956a449.876027 449.876027 0 0 0-62.900672-4.038835h-73.021658v34.473488h137.941747v34.473488c-18.963406-1.314414-39.910381-2.031367-62.876773-2.031367h-75.064974v38.572069h85.209858q40.543689 0 87.229275-2.031367v36.528753q-44.630321-4.026886-87.229275-4.062734H404.367438v18.258402h-42.598954q1.971621-48.669156 2.019417-164.301717-26.383869 44.618372-48.681105 66.915608-14.231516-18.222554-28.403286-26.35997a617.009709 617.009709 0 0 0 39.551904-51.716206q17.230769-25.356236 37.532487-56.806572t34.485437-80.059746q26.288275 14.195668 48.681106 24.340552-10.156833 8.065721-30.422704 40.519791z m273.852129 336.705004q0 42.598954 2.031366 75.064974h-42.598954v-22.297237H398.273338v24.328604h-42.598954a665.571322 665.571322 0 0 0 4.050784-77.096341q0-42.587005-4.050784-73.021658h336.740851q-2.055265 30.434653-2.031366 73.021658z m-40.627334 20.313667v-60.869305H398.273338v60.845407zM524.038835 402.162808V367.677371H404.367438v34.485437z m0 64.90814v-34.473487H404.367438v34.473487z m0 70.990292v-38.548171H404.367438v38.548171z m54.775205-219.064974q-12.1882 4.098581-36.516803 14.183719-6.070202-16.203137-26.35997-46.661688a159.378641 159.378641 0 0 0 34.473487-16.215086q20.253921 32.477969 28.403286 48.693055z"
                        p-id="11645"></path>
                  </svg>
                </div>
                <div class="order-item-right">
                  <p class="order-item-title">待处理售后</p>
                  <p class="order-item-price">
                    {{ totalProfit['SERVICE_APPLY'] && totalProfit['SERVICE_APPLY'].amount || '0' }}</p>
                </div>
              </div>
              <div class="order-item">
                <div class="order-item-left">
                  <svg t="1593673625588" class="icon" viewBox="0 0 1024 1024" version="1.1"
                       xmlns="http://www.w3.org/2000/svg" p-id="12276" width="48" height="48">
                    <path d="M494.52 904.42m0-15l0-210q0-15 15-15l0 0q15 0 15 15l0 210q0 15-15 15l0 0q-15 0-15-15Z"
                          p-id="12277"></path>
                    <path
                        d="M525.71 684.72l-1.16-0.34-42.12-1.38h-0.75l-0.75-0.08a304.66 304.66 0 0 1-139.76-51.72 240.74 240.74 0 0 1-92.6-119.8l-0.32-1a499.56 499.56 0 0 1-14.95-181.55v-0.1c0.7-18.36 1.36-35.7 1.36-52.29v-0.19a54.71 54.71 0 0 1 54.55-53.82h0.61a238.9 238.9 0 0 1 83.25 17.25 196.67 196.67 0 0 1 31.83-47.42c37.09-41.68 70.59-61.95 102.4-61.95h0.87a113.32 113.32 0 0 1 65.36 26 233.23 233.23 0 0 1 41.88 41.06 202.51 202.51 0 0 1 26.87 44.6 279.94 279.94 0 0 1 90.42-19.49H734.67a54.35 54.35 0 0 1 53.59 54c0 27.75-0.54 55.86-1 83l-0.26 12.76c0 4.43-0.11 8.82-0.22 13.07q-0.11 4.11-0.17 8.18c0 5 0 10.11-0.18 15.19a290.39 290.39 0 0 1-11.31 94.49l-0.28 0.86a274 274 0 0 1-246.77 180.58z m-42.51-30.1h0.43l45.54 1.55h0.1A244.67 244.67 0 0 0 748 494.83a261.81 261.81 0 0 0 10-85.39v-1.22c0.18-4.77 0.18-9.87 0.18-14.8v-0.19c0-2.86 0.11-5.72 0.18-8.59 0.11-4.13 0.21-8.39 0.21-12.51v-0.27l0.25-12.89c0.51-27.05 1-55 1-82.41a26.11 26.11 0 0 0-25.54-25.73h-0.65a251.72 251.72 0 0 0-93.31 22.87l-14.12 6.5-5.18-14.66a174.05 174.05 0 0 0-27.91-50.47 204 204 0 0 0-37.06-36.28l-0.58-0.47a84.69 84.69 0 0 0-48.67-19.63c-22.86 0.21-50.05 17.87-80.84 52.49l-0.09 0.11a168.29 168.29 0 0 0-32.32 52.25l-5.52 14.19-13.76-6.52a210.89 210.89 0 0 0-85.12-20.41A26.29 26.29 0 0 0 263 276.57c0 17.1-0.67 34.66-1.38 53.26l-0.08 1.44a471.44 471.44 0 0 0 13.92 171.13 212.68 212.68 0 0 0 81.64 105.32l0.09 0.06a276.29 276.29 0 0 0 126.01 46.84zM617.93 832.92c9.5-22.37 22.36-43.17 37-62.5 1-1.34 2-2.53 4-5q2.79-3.46 5.68-6.85 6.23-7.34 12.83-14.35a224.62 224.62 0 0 1 24-22.25c-2.24 1.77 0.53-0.39 1.08-0.81 1.09-0.81 2.19-1.6 3.29-2.39 2.21-1.56 4.45-3.08 6.73-4.54a163.93 163.93 0 0 1 14.74-8.43c2.16-1.08 4.36-2.1 6.56-3.1 4.77-2.16-3 1.06 1.88-0.76l3-1.13a128.32 128.32 0 0 1 17-4.9c2.54-0.54 5.1-1 7.66-1.39-4.49 0.77 2.3-0.17 3.47-0.25a110.41 110.41 0 0 1 13.49-0.13c2.26 0.12 4.51 0.33 6.75 0.56 4.55 0.47-3.63-0.74 0.86 0.14 0.88 0.18 1.78 0.31 2.67 0.48a103.14 103.14 0 0 1 14.35 3.8c0.84 0.29 1.69 0.6 2.53 0.91s1.67 0.64 2.5 1q-2.7-1.15-1-0.39c2.19 1.09 4.42 2.09 6.57 3.27 2.32 1.28 4.59 2.67 6.78 4.16 0.74 0.5 1.44 1 2.17 1.52q2.28 1.69-0.29-0.24c0.68 0.55 1.36 1.12 2 1.69 1.66 1.45 3.27 3 4.81 4.54 0.92 1 1.82 1.93 2.69 2.93 0.43 0.49 3 4 0.69 0.71a81.3 81.3 0 0 1 8.21 14.13c3.64 8.15 16.13 10.71 23.27 6.1 8.43-5.43 10-14.55 6.1-23.27-18.22-40.72-66.68-60.12-109.2-55.55-52 5.59-93.47 38.89-125.72 78-19.39 23.51-36.64 49-48.59 77.18-3.47 8.16-2.72 18.61 6.1 23.27 7.29 3.85 19.56 2.64 23.27-6.1zM422.53 815.75C412 790.86 397.2 768.26 380.65 747c-15.87-20.42-33.57-39.18-54.29-54.71-37-27.78-87.12-41.81-131.84-25-23.8 8.92-44.93 25.3-55.5 48.93-3.62 8.11-2.62 18.67 6.1 23.27 7.42 3.92 19.39 2.57 23.27-6.1a75.79 75.79 0 0 1 6.61-12.04c0.05-0.07 2.69-3.57 1.06-1.51s1.15-1.31 1.2-1.38a74.39 74.39 0 0 1 5.53-5.7c0.9-0.84 6-4.9 2.65-2.43q2.39-1.79 4.89-3.41a101.67 101.67 0 0 1 12.3-6.61c-3.87 1.81 2.35-0.84 3.43-1.22q3.19-1.1 6.45-2c2.17-0.59 4.37-1.11 6.58-1.56 0.88-0.18 1.77-0.35 2.66-0.51s1.78-0.3 2.67-0.44q-3.42 0.43-0.48 0.07c4.05-0.38 8.09-0.69 12.16-0.7q3.38 0 6.74 0.18c1.34 0.08 2.68 0.18 4 0.31 1 0.09 5.1 0.71 0.79 0a132 132 0 0 1 15.48 3.33c2.57 0.73 5.13 1.54 7.66 2.42 1 0.35 2 0.72 3 1.1l3 1.17-0.36-0.16a160.73 160.73 0 0 1 28.77 16.39c0.88 0.63 1.76 1.26 2.63 1.91 0.13 0.09 4.35 3.36 1.74 1.29 2.12 1.68 4.22 3.4 6.28 5.17 4.11 3.53 8.08 7.23 11.91 11.06a348.9 348.9 0 0 1 24.34 27.22 333.94 333.94 0 0 1 22.36 31.72 266.81 266.81 0 0 1 18.65 35.81c3.49 8.22 16.23 10.64 23.27 6.1 8.55-5.51 9.84-14.47 6.1-23.27z"
                        p-id="12278"></path>
                  </svg>
                </div>
                <div class="order-item-right">
                  <p class="order-item-title">待评价</p>
                  <p class="order-item-price">
                    {{ totalProfit['RECEIVED'] && totalProfit['RECEIVED'].amount || '0' }}</p>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-header>
      <el-main height="auto">
        <el-row>
          <el-col :span="12" style="padding: 15px">
            <el-card>
              <div slot="header">
                <span>本月支付金额</span>
              </div>
              <el-row>
                <el-col>
                  <div :id="thisOrderSuccessMoneyDivId" :style="{height: '300px',width:'100%'}"/>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
          <el-col :span="12" style="padding: 15px">
            <el-card>
              <div slot="header">
                <span>本月退款金额</span>
              </div>
              <el-row>
                <el-col>
                  <div id="returnMoney" :style="{height: '300px',width:'100%'}"/>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
          <el-col style="padding: 15px" v-if="false">
            <el-card>
              <div slot="header">
                <span>商城订单</span>
              </div>
              <el-row>
                <el-col>
                  <div :id="thisOrderSuccessMoneyDivId" :style="{height: '300px',width:'100%'}"/>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>
<script>

export default {
  data() {
    return {
      thisOrderSuccessMoneyDivId: 'thisOrderSuccessMoneyDivId',

      totalOrderCount: {},
      toDayTotalOrderCount: {},
      totalProfit: {},
      toMonthTotalProfit: {},
      toDayTotalProfit: {}
    };
  },
  mounted() {
    let _this = this;
    _this.countThisOrderSuccessMoney()
    _this.countReturnSuccessMoney()

    /**
     * 订单
     */
    this.findTotalOrderCount();
    this.findToDayTotalOrderCount();

    /**
     * 收益
     */
    this.findTotalProfit();
    this.findToMonthTotalProfit();
    this.findToDayTotalProfit();
  },
  methods: {

    toOrderPage(_value) {
      let obj = {name: "orderList"}
      if (_value) {
        Object.assign(obj, {"query": {feeType: _value}});
      }
      console.log(obj);
      this.$router.push(obj);
    },
    findTotalOrderCount() {
      var _this = this;
      _this.$common.my_ajax({
        url: '/order/orderCount',
        repeatKey: "findTotalOrderCount",
        success: function (response) {
          _this.totalOrderCount = response.item || {};
        }
      });
    },
    findToDayTotalOrderCount() {
      var _this = this;
      var date = new Date();
      _this.$common.my_ajax({
        url: '/order/orderCount',
        repeatKey: "findToDayTotalOrderCount",
        data: {
          begin: date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate(),
          end: date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
        },
        success: function (response) {
          _this.toDayTotalOrderCount = response.item || {};
        }
      });
    },
    findTotalProfit() {
      var _this = this;
      _this.$common.my_ajax({
        url: '/orderSellerCount/countByManagerGroupByStatus',
        repeatKey: "totalProfit",
        success: function (response) {
          _this.totalProfit = response.item || {};
        }
      });
    },
    findToMonthTotalProfit() {
      var _this = this;
      _this.$common.my_ajax({
        url: '/orderSellerCount/countByManagerGroupByStatus',
        repeatKey: "findToDayTotalOrderCount",
        data: {
          seleDate: 'CURRENT_MONTH',
        },
        success: function (response) {
          _this.toMonthTotalProfit = response.item || {};
        }
      });
    },
    findToDayTotalProfit() {
      var _this = this;
      _this.$common.my_ajax({
        url: '/orderSellerCount/countByManagerGroupByStatus',
        repeatKey: "toDayTotalProfit",
        data: {
          seleDate: "TODAY",
        },
        success: function (response) {
          _this.toDayTotalProfit = response.item || {};
        }
      });
    },

    countReturnSuccessMoney: function () {
      let _this = this
      const element = document.getElementById('returnMoney');
      if (element && !element.hasChildNodes()) {
        let myChart = _this.$echarts.init(element);
        myChart.showLoading();
        let option = {
          title: {
            text: '本月合计：￥0'
          },
          color: ['#40C9C6'],
          backgroundColor: ['#ffffff'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'line'
            }
          },
          xAxis: {
            type: 'category',
          },
          yAxis: {
            type: 'value'
          },
          series: [{
            name: '退款金額',
            type: 'line',
          }],
        };
        myChart.setOption(option);
        _this.findThisMonthOrderMoney(['SERVICE_SUCCESS']).then(({names, values, sum}) => {
          option.title.text = '本月合计：￥' + sum
          option.xAxis.data = names
          option.series[0].data = values
          console.log(names);
          console.log(values);
          myChart.setOption(option);
        })
        myChart.hideLoading();
      }
    },

    countThisOrderSuccessMoney: function () {
      let _this = this
      const element = document.getElementById(this.thisOrderSuccessMoneyDivId);
      if (element && !element.hasChildNodes()) {
        let myChart = _this.$echarts.init(element);
        myChart.showLoading();
        let option = {
          title: {
            text: '本月合计'
          },
          color: ['#40C9C6'],
          backgroundColor: ['#ffffff'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'line'
            }
          },
          xAxis: {
            type: 'category',
          },
          yAxis: {
            type: 'value'
          },
          series: [{
            name: '成功交易',
            type: 'line',
          }],
        };
        myChart.setOption(option);
        _this.findThisMonthOrderMoney(['SENDED', 'PAYED', 'RECEIVED', 'COMMENTED']).then(({names, values, sum}) => {
          option.title.text = '本月合计:￥' + sum
          option.xAxis.data = names
          option.series[0].data = values
          console.log(names);
          console.log(values);
          myChart.setOption(option);
        })
        myChart.hideLoading();
      }
    },
    findThisMonthOrderMoney: function (statuses) {
      return new Promise((resolve, reject) => {
        var _this = this;
        _this.$common.my_ajax({
          url: '/order/findThisMonthOrderMoney',
          data: statuses,
          methods: 'POST',
          contentType: 'application/json',
          repeatKey: Math.random(),
          success: function (response) {
            let data = response.item.data || [];
            if (data && data.length > 0) {
              let values = []
              let names = []
              for (let i = 0; i < data.length; i++) {
                names.push(data[i].name)
                values.push(parseFloat(data[i].value))
              }
              resolve({names, values, sum: response.item.sum})
            }
          }
        });
      })
    }
  }
};
</script>
<style scoped>
.order {
  text-align: center;
  border: 1px solid #EEEEEE;
  padding: 18px;
}

.order-item {
  border: 1px solid #c3bfcb;
  display: inline-block;
  margin: 12px;
}

.order-item > div p {
  margin: 0;
}

.order-item .order-item-left, .order-item-right {
  float: left;
}

.order-item > .order-item-left {
  padding: 10px;
  background-color: #F2F6FC;
}

.order-item > .order-item-right > .order-item-title {
  padding: 6px 24px;
  font-size: 14px;
  font-weight: bold;
  background: #67C23A;
  color: #fff;
}

.order-item > .order-item-right > .order-item-price {
  padding: 5px 24px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}

.order-item > .order-item-right > p {

}

.order-item > .order-item-left > svg {
  fill: #67C23A;
  width: 100%;
  height: 100%;
}
</style>